<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="用户"
      edit-title
      id-key="UserId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="用户姓名" prop="EmpId" v-if="iShow('EmpId')" label-width="130px">
          <select-input
            placeholder="选择人员"
            :label="data.EmpName"
            v-model="data.EmpId"
            @click="openEmpDialog"
          />
        </el-form-item>
        <el-form-item label="用户账号" prop="LoginId" v-if="iShow('LoginId')" label-width="130px">
          <el-input v-model="data.LoginId" placeholder="请输入用户账号"></el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="RoleId" v-if="iShow('RoleId')" label-width="130px">
          <role-select v-model="data.RoleId" ref="roleSelect"></role-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="DpId" v-if="iShow('DpId')" label-width="130px">
          <el-input v-model="data.DpName"></el-input>
        </el-form-item>

        <!-- h -->
        <el-form-item label="超级权限" prop="IsSuper" v-if="EditIsSuper" style="background-color: rgb(255, 240, 221);" label-width="130px">
          <el-radio-group v-model="data.IsSuper">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- h -->

        <el-form-item label="状态" prop="Status" v-if="iShow('Status')" label-width="130px">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="大屏页面权限" prop="ScreenPageAuth" label-width="130px">
          <el-checkbox-group v-model="screenPageAuthChecked">
            <el-checkbox label="0">设备概况</el-checkbox>
            <el-checkbox label="1">机台数据分析</el-checkbox>
            <el-checkbox label="2">设备状态</el-checkbox>
            <el-checkbox label="3">实时数据</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="机台数据分析分页" label-width="130px">
          <el-switch v-model="data.ScreenMachineAnalysisByDp" active-text="按部门分页" inactive-text="普通分页"></el-switch>
        </el-form-item>

        <!-- h -->
        <div v-show="false">
          <div class="QxBody">
            <div class="QxTitle">往来单位数据权限</div> <!-- 往来单位性质(客户/供应商/客户&供应商 / 外协) -->            
            <el-checkbox v-model="data.QxKh">客户</el-checkbox>
            <el-checkbox v-model="data.QxGys">供应商</el-checkbox>
            <el-checkbox v-model="data.QxKhgys">客户&供应商</el-checkbox>
            <el-checkbox v-model="data.QxWx">外协</el-checkbox>
          </div>
          <div class="QxBody">
            <div class="QxTitle">生产工序数据权限</div>
            <stage-list ref="qxStageList" />
          </div>
          <div class="QxBody">
            <div class="QxTitle">仓库数据权限</div>
            <store-list ref="qxWarehouseList" />
          </div>
        </div>
        <!-- h -->
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
const loginInfo = JSON.parse(localStorage.getItem("loginInfo")); // <!-- h -->
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import roleSelect from "@/components/sys/role/select";
import empDialog from "@/components/personnel/result/record/listDialog";
import iForm from '@/data/sys/user/IForm.json'
import stageList from "./stageList"; // <!-- h -->
import storeList from "./storeList"; // <!-- h -->
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    roleSelect,
    empDialog,
    stageList, // <!-- h -->
    storeList, // <!-- h -->
  },
  data() {
    return {
      data: {
        UserId: 0,
        EmpId: null,
        EmpName: "",
        EmpNo: "",
        LoginId: "",
        Status: 1,
        RoleId: null,
        RoleName: "",
        // Pwd: "",
        DpId: null,
        DpName: "",
        QxKh: null, // <!-- h -->
        QxGys: null, // <!-- h -->
        QxKhgys: null, // <!-- h -->
        QxWx: null, // <!-- h -->
        IsSuper: 0, // <!-- h -->

        QxStageList: [], // <!-- h -->
        QxWarehouseList: [], // <!-- h -->
        ScreenPageAuth: "", // 大屏页面权限
        ScreenMachineAnalysisByDp: false, // 大屏机台数据分析按部门分页
      },
      EditIsSuper: false, // <!-- h -->
      screenPageAuthChecked: [], // 大屏页面权限选中的数组
      formApi: require('@/api/sy/formSetting').default,
      api: require("@/api/sy/user").default,
      userDataPerApi: require("@/api/sy/userdataper").default,
      //加工类型
      machiningStageApi: require('@/api/ba/machiningStage').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      trendData: iForm.Data,
      showList:[],
      rules: {
        EmpId: [{ required: true, message: "请选择人员" }],
        LoginId: [{ required: true, message: "登录账号不能为空" }],
        RoleId: [{ required: true, message: "请选择所属角色" }],
        DpId: [{ required: true, message: "请选择所属部门" }],
      },
    };
  },
  watch: {
    // 监听screenPageAuthChecked变化，更新ScreenPageAuth
    screenPageAuthChecked(newVal) {
      this.data.ScreenPageAuth = newVal.join(",");
    },
  },

  methods: {
    // 打开时获取显示显示列表
    onOpened(){
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({type:modeName}).then(res=>{
        this.showList = res.Data?.map(x=>x.ShowField)
      })
    },
    onCreateOpened(data) {
      console.log('onCreateOpened');
      this.EditIsSuper = loginInfo.IsSuper; // <!-- h -->
      this.setQx({UserId: 0}); // <!-- h -->
      // 初始化大屏页面权限为全选
      this.screenPageAuthChecked = ["0", "1", "2", "3"];
    },
    //判断显示
    iShow(data){
      if(!this.showList || this.showList.length === 0) return true;
      return this.showList.indexOf(data) != -1 ? true : false
    },
    
    onEditOpened(data) {
      console.log('onEditOpened', data);
      this.EditIsSuper = loginInfo.IsSuper; // <!-- h -->
      this.setQx(data); // <!-- h -->
      // 加载大屏页面权限
      if (data.ScreenPageAuth) {
        this.screenPageAuthChecked = data.ScreenPageAuth.split(",");
      } else {
        // 如果没有权限设置，默认全选
        this.screenPageAuthChecked = ["0", "1", "2", "3"];
      }
    },
    setQx(data) {
      // <!-- h -->
      this.userDataPerApi.list({ UserId: data.UserId }).then(res => {
        this.qxList = res.Data;
        var stageList = [];
        var warehouseList = [];
        this.qxList.forEach(item => {
          if (item.PerType == "生产工序") {
            stageList.push({Name: item.PerName});
          } else if (item.PerType == "仓库") {
            warehouseList.push({WarehouseName: item.PerName});
          }
        });
        
        this.machiningStageApi.list({ Status: 1, IsFullStage: true }).then(res => {
          this.$refs.qxStageList.setData(res.Data, stageList);
        });
        this.warehouseApi.list({ Status: 1, IsFullStage: true }).then(res => {
          this.$refs.qxWarehouseList.setData(res.Data, warehouseList);
        });
      });
      // <!-- h -->      
    },
    openEmpDialog() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
   
    setEmp(emp) {
      console.log(emp);
      this.data.EmpId = emp.EmpId;
      this.data.EmpName = emp.EmpName;
      this.data.EmpNo = emp.EmpNo;
      this.data.DpId = emp.DpId;
      this.data.DpName = emp.DpName;
    },
    onClosed(){
      this.showList = [];

    },
    onBeforeSave() {
      // <!-- h -->
      var chkStage = this.$refs.qxStageList.getChecked();
      while (this.data.QxStageList.length > 0) {
        this.data.QxStageList.pop();
      }
      if (chkStage && chkStage.length > 0) {
        chkStage.forEach((x) => {
          this.data.QxStageList.push(x);
        });
      }    
      var chkWarehouse = this.$refs.qxWarehouseList.getChecked();
      while (this.data.QxWarehouseList.length > 0) {
        this.data.QxWarehouseList.pop();
      }
      if (chkWarehouse && chkWarehouse.length > 0) {
        chkWarehouse.forEach((x) => {
          this.data.QxWarehouseList.push(x);
        });
      }
      // <!-- h -->
    },
  },
};
</script>
<style scoped>
  .QxTitle{
    font-weight: bold;
    font-size: 13px;
    color: #666;
    margin-bottom: 10px;
  }
  .QxBody{
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }
</style>